import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=03cf9752&scoped=true&"
import script from "./rich-editor.vue?vue&type=script&lang=js&"
export * from "./rich-editor.vue?vue&type=script&lang=js&"
import style0 from "./rich-editor.vue?vue&type=style&index=0&id=03cf9752&prod&lang=less&scoped=true&"
import style1 from "./rich-editor.vue?vue&type=style&index=1&id=03cf9752&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf9752",
  null
  
)

export default component.exports